import {handleActions} from 'redux-actions';
import {Map, List} from 'immutable';

import * as Actions from './actions';

// Generally, when we load versions of a product, we have to clear all previously known versions from the state.
// Otherwise we can get out of sync with the validFrom/validTo dates on the backend
const allSuccessful = (state, products, filterIds) => {
    const newState = state.filter(product => !filterIds.includes(product.productId));
    return newState.merge(Map(products.map(product => [product.version, product])));
};

export default handleActions(
    {
        [Actions.fetchSuccess.type]: (state, {payload}) => {
            const firstProduct = payload.products[0];
            return allSuccessful(state, payload.products, List([firstProduct.productId]));
        },

        [Actions.fetchAllSuccess.type]: (state, {payload}) => {
            const productIds = payload.filterCurrent ? payload.products.map(s => s.productId) : List();
            return allSuccessful(state, payload.products, productIds);
        },

        [Actions.createSuccess.type]: (state, {payload}) =>
            state.update(payload.product.version, () => payload.product),

        [Actions.updateSuccess.type]: (state, {payload}) => {
            const {oldProduct, newProduct} = payload;
            // Make sure the old version is removed since new version can have a different id
            return state.filter(product => product.version !== oldProduct.version).set(newProduct.version, newProduct);
        },

        [Actions.restoreSuccess.type]: (state, {payload}) =>
            state.update(payload.product.version, () => payload.product),

        [Actions.removeSuccess.type]: (state, {payload}) =>
            state.update(payload.product.version, () => payload.product),

        [Actions.unscheduleSuccess.type]: (state, {payload}) => {
            const removedUnscheduled = state.remove(payload.unscheduledProductVersionId);

            if (payload.remainingVersions.length === 0) {
                return removedUnscheduled;
            } else {
                return allSuccessful(
                    removedUnscheduled,
                    payload.remainingVersions,
                    List([payload.remainingVersions[0].productId]),
                );
            }
        },
    },
    Map(),
);
